import { Box, Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';
import Lottie from 'lottie-react';
import illustration from '../../../lotties/hero.json';
import { Nav } from 'react-bootstrap';

const InfoComponent = () => {
  return (
    <Container maxWidth="lg">
      <div className={styles.InfoDiv}>
        <Grid container spacing={5} className="d-flex align-items-center">
          <Box clone order={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
            <Grid item md={5} xl={5} lg={5} sm={12} xs={12}>
              <h1 className={styles.secondaryText}>Sell your products to</h1>
              <h1 className={styles.highlightedMainText}>100K+ retailers</h1>
              <p className={`${styles.childText} mt-5`} style={{ fontSize: '20px' }}>
                Thousands of Distributors, Wholesalers and <br />
                OEM’s use falcon to sell their products
                <br />
                across India.
              </p>
              <Nav.Link href="/onboarding" className="p-0">
                <Button
                  className={` ${styles.btnPadding} ${styles.commonButtonBg}`}
                  variant="contained"
                  color="primary"
                  moenagage-id={JSON.stringify({
                    eventName: 'User_Registration_initiation',
                    eventSource: 'Info section of landing page',
                  })}
                >
                  Get Started
                </Button>
              </Nav.Link>
            </Grid>
          </Box>
          <Box clone order={{ xs: 1, sm: 1, md: 2, lg: 2 }}>
            <Grid
              item
              md={7}
              lg={7}
              xl={7}
              sm={12}
              xs={12}
              className="d-flex justify-content-center"
            >
              <div className={styles.illustratorContainer}>
                {/* <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="/images/illustration.svg"
            ></img> */}
                <Lottie animationData={illustration} />
                {/* <video width="100%" height="100%" autoPlay muted loop>
                  <source src="/images/video.mp4" type="video/mp4" />
                </video> */}
              </div>
            </Grid>
          </Box>
        </Grid>
      </div>
    </Container>
  );
};
export default InfoComponent;
